const state = {
  dTime: 0,
  aliveList: [],
  isBack: false,
  showTitle: false,
  title: 'fgoWiki',
  isWeixin:
    navigator.userAgent.toLowerCase().match(/MicroMessenger/i) === 'micromessenger',
  canGoBack: false,
};
const getters = {
  hasTitle(inoNewState) {
    return inoNewState.showTitle && !inoNewState.isWeixin;
  },
};
const mutations = {
  setDTime(inoNewState, date) {
    const coState = inoNewState;
    const cdtNow = new Date();
    coState.dTime = cdtNow - new Date(date);
  },
  setCanGoBack(inoNewState, flag) {
    inoNewState.canGoBack = flag; // eslint-disable-line
  },
  setAliveList(inoNewState, list) {
    inoNewState.aliveList = list; // eslint-disable-line
  },
  setShowTitle(inoNewState, data) {
    inoNewState.showTitle = data; // eslint-disable-line
  },
  setTitle(inoNewState, text) {
    inoNewState.title = text; // eslint-disable-line
  },
  setIsBack(inoNewState, flag) {
    inoNewState.isBack = flag;  // eslint-disable-line
  },
};
const actions = {};
export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
